import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';
import { ButtonWithArrow } from '../ButtonWithArrow/index.js';
import { SelectCustom } from '../SelectCustom/index.js';

const SELECT_CUSTOM_BUTTON_ID = 'select-custom-button-id';
const StyledSelectCustom = styled(SelectCustom)`
  /* targets Popover's ul, needed to make Popover only 5 items tall */
  ul {
    height: 100%;
    max-height: 240px;
    overflow-y: auto;
  }

  .select--customLabel {
    svg {
      width: 12px;
      height: 12px;
      margin-left: -${ndsTokens.space.generic.x1};
      position: relative;
      top: 1px;
    }
  }

  button {
    padding: ${ndsTokens.space.generic.x2};
    &:active {
      pointer-events: auto;
      overflow: visible;
      &::before {
        display: block;
        position: absolute;
        top: -2px;
        right: -2px;
        bottom: -2px;
        left: -2px;
        opacity: 1;
        animation-duration: 500ms;
        animation-fill-mode: forwards;
        border-width: ${ndsTokens.space.generic.x1};
        border-style: solid;
        border-color: ${ndsTokens.colors.palette.gray.darkest};
        border-radius: 5px;
      }
    }
  }
`;
const NextButtonWithArrow = styled(ButtonWithArrow)`
  margin-left: ${ndsTokens.space.generic.x1};

  &:focus {
    outline: ${ndsTokens.colors.palette.gray.medium} dashed 1px;
  }
`;
const PreviousButtonWithArrow = styled(ButtonWithArrow)`
  margin-right: ${ndsTokens.space.generic.x1};

  &:focus {
    outline: ${ndsTokens.colors.palette.gray.medium} dashed 1px;
  }
`;
const ButtonWithArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    align-items: center;
    justify-content: center;
  }
`;
const RootDiv = styled.div`
  ${ndsFontReset()}
  color: ${ndsTokens.colors.text.onLight.primary};
  display: inline-flex;
  justify-content: center;
  max-width: 375px;
  width: 100%;

  button:hover {
    text-decoration: underline;
    background: none;
  }
  button[disabled] {
    opacity: 0.4;
  }
`;
const StyledSpan = styled.span`
  font-size: ${ndsTokens.font.size.text.large};
`;

const Pagination = ({
  currentPage = 1,
  'data-test': testId = 'pagination',
  prevDisabled,
  nextDisabled,
  prevOnClick,
  nextOnClick,
  pages = [],
  onPageSelect = () => {},
  className,
  selectCustomId = SELECT_CUSTOM_BUTTON_ID
}) => {
  const totalPages = pages === null || pages === void 0 ? void 0 : pages.length;
  return jsxs(RootDiv, Object.assign({
    className: className,
    "data-test": testId
  }, {
    children: [jsx(ButtonWithArrowWrapper, {
      children: jsx(PreviousButtonWithArrow, {
        "aria-label": "previous page",
        "data-test": "previous",
        direction: "previous",
        disabled: prevDisabled,
        onClick: prevOnClick
      }, void 0)
    }, void 0), jsx(StyledSelectCustom, {
      autoLabelUpdate: true,
      boldValue: true,
      "data-test": "select",
      flip: true,
      id: selectCustomId,
      onChange: onPageSelect,
      options: pages,
      placement: "bottom",
      renderPopoverInline: true,
      target: selectCustomId,
      value: currentPage === null || currentPage === void 0 ? void 0 : currentPage.toString(),
      valueRenderer: value => jsx(StyledSpan, {
        children: `${value} of ${totalPages}`
      }, void 0),
      variant: "borderless"
    }, void 0), jsx(ButtonWithArrowWrapper, {
      children: jsx(NextButtonWithArrow, {
        "aria-label": "next page",
        "data-test": "next",
        direction: "next",
        disabled: nextDisabled,
        onClick: nextOnClick
      }, void 0)
    }, void 0)]
  }), void 0);
};

Pagination.displayName = 'Pagination';

export { Pagination };
